export const TOKEN_KEY = 'token';
export const USER_KEY = 'user';
export const LANG_KEY = 'lang';
export const ADMIN = 'administrator';
export const PILOT = 'agri_pilot';
export const UPLOAD_PERMISSIONS_STRING = 'uav.image.upload';
//# sourceMappingURL=constants.js.map